import clsx from 'clsx'
import CodeViewer from 'components/CodeViewer/CodeViewer'
import { formatJSON } from 'helpers/format'
import { CopyIcon } from 'lucide-react'
import { IdEventV4 } from 'models/event'

import { IdentificationUrlKeys } from '../../../types'
import { SmartSignalDefinition } from './SmartSignalRepresentation'

export const clonedAppDefinition: SmartSignalDefinition<{ cloned_app?: IdEventV4['cloned_app'] }> = {
  key: 'cloned-app',
  label: 'Cloned app',
  extract: (e) => ({ cloned_app: e.cloned_app }),
  icon(e) {
    const p = this.extract(e)?.cloned_app
    return (
      <CopyIcon
        className={clsx('size-4', {
          'text-red-800': p,
        })}
      />
    )
  },
  details(e) {
    return (
      <CodeViewer
        value={formatJSON(this.extract(e))}
        withSearch={false}
        className={this.isDetected(e) ? 'bg-red-100 border-red-300' : 'bg-gray-100'}
      />
    )
  },
  isDetected(e) {
    const p = this.extract(e)?.cloned_app
    return p === true
  },
  isWeb: () => false,
  isMobile: () => true,
  searchFor: '"cloned_app":',
  documentationHash: '#cloned-app-detection',
  urlParamKey: IdentificationUrlKeys.ClonedApp,
}
